export const currentBasketUUID = state => state.voucherPaymentsBasket.currentBasketUUID;
